<template>
  <Strip
    v-if="isActiveBanner"
    :color-bg="banners.color"
    :actions="actions"
    :title="title"
    :description="description"
    @click="redirectCampaign"/>
</template>

<script>

import configFactory from "@/configFactory";
import {computed, getCurrentInstance} from "vue";
import {storeToRefs} from "pinia";
import profile from "@/store/profile";
import {useCampaignStore} from "@/store/campaign";
import Strip from "@/design/Strip.vue";

export default {
  name: "CampaignBanner",
  components: {Strip},
  props: {
    actions: Boolean
  },
  setup() {
    const {isInfluencer} = profile.state

    const {$i18n} = getCurrentInstance().proxy
    const {isActiveBanner, banners, filename} = storeToRefs(useCampaignStore())

    const newConfig = configFactory().getConfig();
    console.log(banners)
    const title = computed(() => `${banners.value.title[$i18n.locale]}`)
    const description = computed(() => `${banners.value.description[$i18n.locale]}`)

    const redirectCampaign = () => {
      const urlBase = `${newConfig.campaignUrl}/campaigns/promo/${filename.value}`
      if (isInfluencer.value) {
        window.location.href = `${urlBase}/academy.html`
      } else {
        window.location.href = `../../../public/index.html`
      }
    }

    return {isActiveBanner, banners, title, description, redirectCampaign}
  }
}

</script>
